
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: "ParkinsonsDiseaseCriteria",
components: {
XTable,
},
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/ParkinsonsDiseaseCriteria.vue